// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu6/Item.css
// module id = 2038
// module chunks = 0